export default __webpack_public_path__ + "static/media/banner.fba14878.jpg";